const getTimestampString = () => (new Date()).toISOString()

export default getTimestampString
